/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CustomerVehicleQuantityControllerService } from './services/customer-vehicle-quantity-controller.service';
import { VehicleTypeControllerService } from './services/vehicle-type-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CustomerVehicleQuantityControllerService,
    VehicleTypeControllerService,
    ApiConfiguration
  ],
})
export class CustomersVehiclesModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersVehiclesModule> {
    return {
      ngModule: CustomersVehiclesModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersVehiclesModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersVehiclesModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
